export const SELECT_ONE_CLICK_APPLICATION_OFFER = 'SELECT_ONE_CLICK_APPLICATION_OFFER';